import { Pipe, PipeTransform } from '@angular/core';
import { DateTime, LocaleOptions } from 'luxon';

@Pipe({
    name: 'lxLocaleString',
    standalone: true,
})
export class LuxonToLocaleStringPipe implements PipeTransform {
  transform(value: number | string | DateTime, options?: LocaleOptions & Intl.DateTimeFormatOptions): string {
    let dateTime: DateTime;

    if (!value) {
      return '';
    }

    if (typeof value === 'string') {
      dateTime = DateTime.fromISO(value);
    } else if (typeof value === 'number') {
      dateTime = DateTime.fromMillis(value);
    } else {
      dateTime = value;
    }

    if (!DateTime.isDateTime(dateTime) || !dateTime.isValid) {
      console.warn(`Invalid input to lxLocaleString: ${value}`);
      return '';
    }

    return dateTime.toLocaleString(options);
  }
}
